import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { AGENT_BUILDER_SERVICE } from './shared/services/agent-builder.token';
import { MockAgentBuilderService } from './shared/services/mock-agent-builder.service';
import { RealAgentBuilderService } from './shared/services/real-agent-builder.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Soft cross-fade between pages (home → builder); the browser default
    // view-transition is enough — no per-route animation config needed.
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    // Phase 1 DI seam (P1-G1): mock vs real picked by env flag. Components
    // inject AGENT_BUILDER_SERVICE token only.
    {
      provide: AGENT_BUILDER_SERVICE,
      useClass: environment.useMockData ? MockAgentBuilderService : RealAgentBuilderService,
    },
  ]
};
